import React from 'react';
import { Modal, Button, Icon } from 'semantic-ui-react';
import {
  getPortabilidadeTipoLabel,
  type PortabilidadeConflict,
} from '../../utils/portabilidadeContractRules';

export interface PortabilidadeConflictModalProps {
  open: boolean;
  conflict: PortabilidadeConflict | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const PortabilidadeConflictModal: React.FC<PortabilidadeConflictModalProps> = ({
  open,
  conflict,
  onConfirm,
  onCancel,
}) => {
  if (!conflict || !conflict.conflict) return null;

  if (conflict.kind === 'tipo') {
    const existingLabel = getPortabilidadeTipoLabel(conflict.existingTipo);
    const newLabel = getPortabilidadeTipoLabel(conflict.newTipo);

    return (
      <Modal open={open} size="small" onClose={onCancel}>
        <Modal.Header>
          <Icon name="warning sign" color="orange" />
          Tipo de portabilidade diferente
        </Modal.Header>
        <Modal.Content>
          <p>
            Este contrato já tem {conflict.affectedCount}{' '}
            {conflict.affectedCount === 1 ? 'linha' : 'linhas'} de portabilidade{' '}
            <strong>{existingLabel}</strong>. A linha atual será <strong>{newLabel}</strong>.
          </p>
          <p>Todas as linhas de portabilidade do contrato precisam ser do mesmo tipo.</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onCancel}>Cancelar</Button>
          <Button primary onClick={onConfirm}>
            Converter anteriores para {newLabel}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }

  if (conflict.kind === 'cedente') {
    return (
      <Modal open={open} size="small" onClose={onCancel}>
        <Modal.Header>
          <Icon name="warning sign" color="orange" />
          Cedente de portabilidade diferente
        </Modal.Header>
        <Modal.Content>
          <p>
            Este contrato já usa o cedente <strong>{conflict.canonical.razaoSocial}</strong> (CNPJ{' '}
            {conflict.canonical.cnpj}) nas outras linhas CNPJ→CNPJ (cedente).
          </p>
          <p>
            A linha atual tem <strong>{conflict.newCedente.razaoSocial}</strong> (CNPJ{' '}
            {conflict.newCedente.cnpj}). Todas as linhas devem ter o mesmo CNPJ cedente (o representante
            pode ser reutilizado ou definido por linha).
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onCancel}>Cancelar</Button>
          <Button primary onClick={onConfirm}>
            Usar este cedente em todas as linhas
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }

  return null;
};

export default PortabilidadeConflictModal;
